import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import {
  ADD_YOUR_VEHICLE_TEXT,
  NEXT_APPOINTMENT_TEXT,
  NO_APPOINTMENTS_TEXT,
  YOU_CAN_REQUEST_APPOINTMENT_TEXT
} from 'components/MyGarage2.0/constants'
import InformationalMessage from './components/InformationalMessage/index'
import Button from 'components/common/Button/Button'
import AppointmentItem from './components/AppointmentItem'

const BOTMyAppointmentsDetailsMyGarage = ({
  className,
  isInfoMessageVisible,
  setIsInfoMessageVisible,
  nextAppointmentVehicle,
  hasActiveVehicle,
  userHasAppointments,
  nextAppointment,
  nextAppointments,
  updateCancelAppointment,
  isMyGaragePage,
  isVehicleDetailsPage,
  appointmentButtonLabel,
  onClick
}) =>
  <Wrapper className={ className }>

    <Header>
      <HeaderTitleWrapper>
        <Icon asset="car-calendar" width="18px" height="20px" alt="Calendar icon" />
        <HeaderTitle>{NEXT_APPOINTMENT_TEXT}</HeaderTitle>
      </HeaderTitleWrapper>
    </Header>

    <MainContent hasActiveVehicle={ hasActiveVehicle }>
      {isInfoMessageVisible && (
        <InfoMessage
          setIsInfoMessageVisible={ setIsInfoMessageVisible }
          userHasAppointments={ userHasAppointments } />
      )}

      {(userHasAppointments && isMyGaragePage) && (
        <AppointmentItem
          updateCancelAppointment={ updateCancelAppointment }
          nextAppointment={ nextAppointment }
          userVehicle={ nextAppointmentVehicle } />)
      }

      {(userHasAppointments && isVehicleDetailsPage) && (
        nextAppointments.map(appointment => (
          <AppointmentItem
            key={ appointment.orderId }
            className="vehicle-details-appointment-item"
            updateCancelAppointment={ updateCancelAppointment }
            nextAppointment={ appointment }
            userVehicle={ nextAppointmentVehicle } />
        ))
      )}

      {!userHasAppointments && (
        <>
          <LargeIcon asset="book-appointment-red" alt="Calendar icon" hasActiveVehicle={ hasActiveVehicle } />

          <NoAppointmentsText>
            {NO_APPOINTMENTS_TEXT}
            <br />
            {hasActiveVehicle ? YOU_CAN_REQUEST_APPOINTMENT_TEXT : ADD_YOUR_VEHICLE_TEXT}
          </NoAppointmentsText>
        </>
      )}

      {(hasActiveVehicle && !userHasAppointments) && (
        <AppointmentButton data-at-myaccount-makeanappointment narrow full="mobile" onClick={ onClick }>
          { appointmentButtonLabel }
        </AppointmentButton>
      )}

    </MainContent>
  </Wrapper>

BOTMyAppointmentsDetailsMyGarage.propTypes = {
  appointmentButtonLabel: PropTypes.string,
  className: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  isInfoMessageVisible: PropTypes.bool,
  isMyGaragePage: PropTypes.bool,
  isVehicleDetailsPage: PropTypes.bool,
  nextAppointment: PropTypes.shape(),
  nextAppointments: PropTypes.arrayOf(PropTypes.shape()),
  nextAppointmentVehicle: PropTypes.shape(),
  onClick: PropTypes.func,
  setIsInfoMessageVisible: PropTypes.func,
  updateCancelAppointment: PropTypes.arrayOf(PropTypes.shape()),
  userHasAppointments: PropTypes.bool
}

export default BOTMyAppointmentsDetailsMyGarage

const Wrapper = styled.div`
  grid-area: NextAppointment;
  width: 100%;
  padding: 24px 16px;
  border: 1px solid ${Theme.colors.gainsboro};
  border-radius: 4px;
  background-color: ${Theme.colors.white};
`

const Header = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding-bottom: 16px;
  justify-content: space-between;
  align-items: center;

  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
    height: 2px;
    width: 100%;
    background-color: ${Theme.colors.gainsboro};
    border-radius: 2px;
  }
`

const HeaderTitleWrapper = styled.div`
  width: fit-content;
  display: flex;

  @media (max-width: 500px) {
    align-items: center;
  }
`

const HeaderTitle = styled.p`
  margin: 0 0 0 8px;
  ${Mixin.responsive('font-size', '18px', '14px')}
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  transform: scale(1, 1.3);
`

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${props => props.hasActiveVehicle && css`
    padding: 16px 0 0 0;
  `}

  & .vehicle-details-appointment-item:not(:last-of-type) {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${Theme.colors.black};
  }
`

const InfoMessage = styled(InformationalMessage)`
  ${props => props.userHasAppointments && css`
    margin: 0 0 16px 0;
  `}
`

const LargeIcon = styled(Icon)`
  ${Mixin.responsive('width', '50px', '43px')}
  ${Mixin.responsive('height', '54px', '48px')}
  ${Mixin.responsive('margin', '40px 0', '24px 0')}
  ${props => props.hasActiveVehicle && css`
    margin: 16px 0;
  `}
`

const NoAppointmentsText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: 1%;
  color: ${Theme.colors.dark_grey};
`
const AppointmentButton = styled(Button)`
  width: 220px;
  margin: 20px 0 0;
  padding: 7px 14px 7px;
  font-size: 13px;
  line-height: 1.2;
  cursor: pointer;
  ${Media.desktop`
    float: right;
  `}
`
